import './style.scss';
import GreenTickGif from "../../../../assets/images/green-tick.gif"
import RedCrossGif from "../../../../assets/images/red-cross.gif"

interface IThankYouSectionPSP {
    status: boolean;
    currency: string;
    totalAmount: number;
}

const ThankYouSectionPSP: React.FC<IThankYouSectionPSP> = (props) => {
  const { status = false, currency = '', totalAmount = 0 } = props;
  return (
    <div className="thank-you-section-wrapper-psp">
      <img src={status ? GreenTickGif : RedCrossGif} alt={status ? 'green tick' : 'red cross'} height={105} width={105} />
      <div className={`thank-you-section-body-wrapper-psp ${status ? 'success' : 'failure'}`}>
        <span>{status ? "Thank You" : "Sorry"}</span>
        <span>{status ? "Payment done Successfully" : "Payment Failed"}</span>
        {!!totalAmount && <span>Your payment of {currency === "INR" ? "₹" : currency}{" "}{new Intl.NumberFormat("en-IN").format(totalAmount)} was {status ? 'successful' : 'unsuccessful'}.</span>}
        {/* {status && <div>
            <button onClick={() => window.print()}><PdfIconSvgPSP/>Download Invoice</button>
            <button><PdfIconSvgPSP/>Download E-Ticket</button>
        </div>} */}
      </div>
    </div>
  );
};

export default ThankYouSectionPSP;